<template>
  <main style="opacity: 0;">
    <div class="block">
      <Paragraph
        size="small"
        :text="structure[0].eyelet"
        class="block__eyelet"
        data-anim="fade"
        data-view="false"
      />
      <Counter
        number="01"
        data-anim="fade"
        data-view="false"
      />

      <div data-nav="about">
        <Title
          :size="structure[0].titleSize"
          :text="structure[0].title"
          data-anim="title"
          data-view="false"
          data-siblings
        />
      </div>

      <div class="block__content">
        <Paragraph
          :size="structure[0].textSize"
          :text="structure[0].text"
          data-anim="text"
          data-view="false"
        />
      </div>

      <component
        v-for="(component, key) in extra"
        :key="key"
        :is="component.component"
        :data="component"
      >
      </component>
    </div>
  </main>
</template>

<script>
import Counter from '@/components/text/Counter.vue';
import Title from '@/components/text/Title.vue';
import Paragraph from '@/components/text/Paragraph.vue';
import BulletList from '@/components/BulletList.vue';
import BlockText from '@/components/BlockText.vue';

export default {
  name: 'About',

  components: {
    Counter,
    Title,
    Paragraph,
    BulletList,
    BlockText,
  },

  data() {
    return {
      lines: null,
    };
  },

  computed: {
    structure() {
      const data = this.$store.state.firebase;
      const { lang } = this.$store.state;
      const structure = data.about.structure[lang];
      const s = [];
      Object.keys(structure).forEach((key) => {
        s.push(Object.assign(structure[key].data, {
          component: this.$store.state.settings.components[structure[key].component].component
        }));
      });
      return s;
    },
    extra() {
      const s = this.structure;
      s.splice(0, 1);
      return s;
    },
  },
};
</script>

<style lang="scss" scoped>
.block {
  & + .block {
    margin-top: rem(80px);
  }

  &__eyelet {
    margin-bottom: rem(70px);
  }

  &__content {
    p {
      margin-top: rem(100px);
    }
  }
}
</style>
